import React from "react";
import {
  dateFormat,
  showPairName,
} from "../../../core/helper/date-format";

export default function TradeHistoryDetail(props) {
  let { traHisDetails } = props;
  return (
    <>
      <div
        className="modal fade order-bookexchange-modal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h1 className="modal-title fs-4" id="exampleModalLabel">
                Order Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-2">
              <div className="card">
                <div className="card-body">
                  {traHisDetails &&
                    traHisDetails.orderDetails &&
                    traHisDetails.orderDetails["Trade type"] ? (
                    <>
                      <span
                        className={
                          "fw-bolder order-bookexchange-modal-text-1 capitalizeText color-" +
                          traHisDetails.orderDetails["Trade type"]
                        }
                      >
                        {traHisDetails.orderDetails["Trade type"]}{" "}
                        {traHisDetails.orderDetails["Order type"]}
                      </span>
                      <span className="order-bookexchange-modal-text-2 ms-3">
                        {showPairName(traHisDetails.orderDetails["Pair name"])}
                      </span>
                      <div className="row my-3">
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-6">
                              <p className="order-bookexchange-modal-text-3">
                                Trade type
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Amount
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Created at
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                From currency
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                To currency
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Before Debit
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Fees
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                GST On Fee
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                TDS
                              </p>
                            </div>
                            <div className="col-6">
                              <p
                                className={
                                  "order-bookexchange-modal-text-4 capitalizeText color-" +
                                  traHisDetails.orderDetails["Trade type"]
                                }
                              >
                                {traHisDetails.orderDetails["Trade type"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {props.decimalValue(traHisDetails.orderDetails["Amount"])}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {dateFormat(
                                  traHisDetails.orderDetails["Created at"]
                                )}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {traHisDetails.orderDetails["From currency"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {traHisDetails.orderDetails["To currency"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {props.decimalValue(traHisDetails.orderDetails["Before debit"])} {traHisDetails.orderDetails["Debit currency"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                0.6%
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                18%
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {traHisDetails.orderDetails["Trade type"] === 'sell' ? '1%' : '0%'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-6">
                              <p className="order-bookexchange-modal-text-3">
                                Order ID
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Price
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Progress
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Updated at
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                Status
                              </p>
                              <p className="order-bookexchange-modal-text-3">
                                After Debit
                              </p>
                            </div>
                            <div className="col-6">
                              <p className="order-bookexchange-modal-text-4">
                                {traHisDetails.orderDetails["Order ID"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {props.decimalValue(traHisDetails.orderDetails["Price"])}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {traHisDetails.orderDetails["Progress"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4">
                                {dateFormat(
                                  traHisDetails.orderDetails["Updated at"]
                                )}
                              </p>
                              <p className="order-bookexchange-modal-text-4 capitalizeText">
                                {traHisDetails.orderDetails["Status"]}
                              </p>
                              <p className="order-bookexchange-modal-text-4 capitalizeText">
                                {props.decimalValue(traHisDetails.orderDetails["After debit"])} {traHisDetails.orderDetails["Debit currency"]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="order-bookexchange-modal-text-2 mb-3">
                        PARTIAL ORDERS (
                        {traHisDetails &&
                          traHisDetails.partialOrders &&
                          traHisDetails.partialOrders.length}
                        )
                      </span>
                      <div className="order-bookexchange-modal-table-width" style={{ overflow: 'auto' }}>

                        <table className="mt-3">
                          <thead>
                            <tr>
                              <th scope="col">Executed Date</th>
                              <th scope="col">Price</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Before Credit</th>
                              <th scope="col">After Credit</th>
                              <th scope="col">Credit Amount</th>
                              <th scope="col">Fees + GST</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {traHisDetails.partialOrders &&
                              traHisDetails.partialOrders.length > 0
                              ? traHisDetails.partialOrders.map((elem, i) => {
                                return (
                                  <tr>
                                    <td data-label="Executed Date">
                                      {dateFormat(elem["Executed Date"])}
                                    </td>
                                    <td data-label="Price">{elem["Price"]}</td>
                                    <td data-label="Amount">
                                      {props.decimalValue(elem["Amount"])}
                                    </td>


                                    {/* <td className="capitalizeText">
                                      {elem["Role"]}
                                    </td> */}
                                    {/* <td data-label="Period">
                                      {showPhone(elem["Order ID"])} */}
                                    {/* <AiFillCopy style={{color:"#02b3b4 "}} onClick={()=>copyText({
                                        message: "Order ID copied successfully!",
                                        text: elem['Order ID']
                                      })}/> */}
                                    {/* </td> */}
                                    {elem["execute"] ? (
                                      <>
                                        <td data-label="beforeExecuteBal">
                                          {props.decimalValue(elem["execute"].oldBalance)}
                                        </td>
                                        <td data-label="afterExecuteBal">
                                          {props.decimalValue(elem["execute"].amount)}
                                        </td>
                                        <td data-label="currency">
                                          {props.decimalValue(elem["execute"].difference)}{" "}
                                          {elem["execute"].currency}
                                        </td>

                                      </>
                                    ) : (
                                      <>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </>
                                    )}
                                    {elem["fees"] ? (
                                      <>
                                        <td>
                                          {elem["fees"].value}{" "}
                                          {elem["fees"].currency}
                                        </td>

                                        {/* <td>{elem["fees"].type}</td> */}
                                      </>
                                    ) : (
                                      <>
                                        <td></td>
                                        {/* <td></td> */}
                                      </>
                                    )}
                                    <td
                                      data-label="Status"
                                      className={
                                        "capitalizeText clr-" + elem["Status"]
                                      }
                                    >
                                      {elem["Status"]}
                                    </td>
                                  </tr>
                                );
                              })
                              : ""}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <h5 className="text-white">Loading...</h5>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
